import productConfig from "emun.products/product.config";
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import Product from "emun.shopping/product.model";
import shoppingConfig from "emun.shopping/shopping.config";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import utils from 'webutils/services/util';

const productSorter = scan => (a, b) => {
	const aI = a.id.indexOf(scan);
	const bI = b.id.indexOf(scan);
	if (aI === -1 && bI >= 0) return 1;
	if (bI === -1 && aI >= 0) return -1;
	if (aI >= 0 && bI >= 0 && aI > bI) return 1;
	if (aI >= 0 && bI >= 0 && bI > aI) return -1;
	if (bI === aI && aI >= 0) {
		const skuComp = skuLengthSorter(a, b);
		if (skuComp !== 0) return skuComp;
		return availableQtySorter(a, b);
	}
	return availableQtySorter(a, b);
};
const skuLengthSorter = (a, b) => {
	if (a.id.length > b.id.length) return 1;
	if (b.id.length > a.id.length) return -1;
	return 0;
};
const availableQtySorter = (a, b) => {
	if (a.availableQty > b.availableQty) return -1;
	if (b.availableQty > a.availableQty) return 1;
	return 0;
};

export default class PromoProductPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selectedProducts = [];
		Object.assign($ctrl, options);
		console.debug("ProductPickerController", { $ctrl, options });
		$ctrl.totalSelectedDollars = 0;
		$ctrl.bus = new ServiceBus();
		$ctrl.prodQuery = new AutoQuery($ctrl.getQueryOptions());
		$ctrl.invalid = false;
	}

	getQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryProducts.json?V=Scan",
			autoLoad: false,
			criteria: {
				//  IsRestricted: 0
			},
			pageSize: 12,
			scrub: res =>
				(res.data.results = Product.map(
					res.data.results.sort(productSorter($ctrl.prodQuery.criteria.scan))
				)),
			onLoaded: args => $ctrl.productsLoaded(args)
		};
	}

	setProduct(p) {
		const $ctrl = this;
		console.info("setProduct", p);
		$ctrl.products = [];
		$ctrl.$selectedIndex = null;
		$ctrl.invalid = false;
		$ctrl.product = p;
		$ctrl.quantity = 1;
		$ctrl.prodQuery.criteria.scan = "";

		if (($ctrl.totalSelectedDollars + p.price) > $ctrl.dollarsAllowed) {
			modals.alert("Not enough remaining dollars to spend");
			return;
		}
		p.uuid = utils.uuid();
		$ctrl.selectedProducts.push(p);
		$ctrl.refreshTotal();
		$ctrl.$emit("cart-item-added");
	}

	refreshTotal() {
		const $ctrl = this;
		$ctrl.totalSelectedDollars = 0;
		$ctrl.selectedProducts.map(obj => {
			$ctrl.totalSelectedDollars += obj.price;
		});
	}

	delete(p) {
		const $ctrl = this;
		$ctrl.selectedProducts.splice($ctrl.selectedProducts.findIndex(item => item.uuid === p.uuid), 1);
		$ctrl.refreshTotal();
	}

	loadProducts(watchSelectedIndex) {
		const $ctrl = this;
		if (($ctrl.prodQuery.criteria.scan || "").length >= 3 ) {
			$ctrl.$selectedIndex = null;
			$ctrl.product = null;
			$ctrl.prodQuery.load(true);
		} else {
			$ctrl.products = [];
		}
	}

	productsLoaded(args) {
		const $ctrl = this;
		$ctrl.products = args.results;
		$ctrl.invalid = false;
		$ctrl.product = null;
		$ctrl.$lastScan = $ctrl.prodQuery.criteria.scan;
		if (
			args.results.length === 1 &&
			(args.first.id.toUpperCase() ===
				$ctrl.prodQuery.criteria.scan.toUpperCase() ||
				args.first.upcCode.toUpperCase() ===
				$ctrl.prodQuery.criteria.scan.toUpperCase())
		) {
			$ctrl.setProduct(args.first);
		} else if (args.results.length === 0) {
			$ctrl.invalid = true;
		} else {
			$ctrl.$selectedIndex = 0;
		}
	}
	clear() {
		const $ctrl = this;
		$ctrl.quantity = null;
		$ctrl.product = null;
		$ctrl.$selectedIndex = null;
		$ctrl.prodQuery.criteria.scan = "";
		$ctrl.products = [];
	}


/*	toggle(product) {
		const $ctrl = this;
		console.log("toggle", product.id, $ctrl.selected, product);
		if ($ctrl.single) {
			$ctrl.onProductSelected &&
				$ctrl.onProductSelected({ $product: product, ...$ctrl });s
			$ctrl.$close(product);
		} else if (product.id in $ctrl.selected) {
			delete $ctrl.selected[product.id];
			$ctrl.totalSelectedDollars -= product.price;
			$ctrl.onProductUnSelected &&
				$ctrl.onProductUnSelected({ $product: product, ...$ctrl });
		} else {
			if ($ctrl.dollarsAllowed > 0) {
				if (($ctrl.totalSelectedDollars + product.price) > $ctrl.dollarsAllowed) {
					modals.alert("Not enough remaining dollars to spend");
					return;
				}
			}
			$ctrl.totalSelectedDollars += product.price;
			$ctrl.selected[product.id] = true;
			$ctrl.onProductSelected &&
				$ctrl.onProductSelected({ $product: product, ...$ctrl });
		}
		this.setProductIds();
	}
	*/

}
